<template>
    <div>
        <v-card>
            <v-card-title class="blue-grey darken-4 white--text">{{ title }}</v-card-title>

            <v-card-text>
                <v-container>
                    <v-row>
                        <v-col>
                            <v-select v-model="form.events" :items="events" label="Event(s)" multiple />
                        </v-col>

                        <v-col>
                            <v-select v-model="form.levels" :items="levels" label="Level(s)" multiple />
                        </v-col>

                        <v-col>
                            <v-select v-model="form.genders" :items="['F', 'M']" label="Gender(s)" multiple />
                        </v-col>

                        <v-col>
                            <v-btn @click="retrieve">Retrieve</v-btn>
                        </v-col>
                    </v-row>

                    <v-divider />

                    <v-row>
                        <v-col>
                            Aggregators
                            <v-btn @click="addAggregator">Add </v-btn>
                        </v-col>
                    </v-row>

                    <v-row>
                        <template v-for="(aggregator, index) in aggregators">
                            <v-col :key="`aggregator-${index}`">
                                <v-select v-model="aggregator.aggregator" :items="calculatorFields" />
                            </v-col>

                            <v-col :key="`field-${index}`">
                                <v-select v-model="aggregator.field" :items="aggregatorFields" />
                            </v-col>
                        </template>
                    </v-row>
                </v-container>
            </v-card-text>
        </v-card>
    </div>
</template>

<script>
import levels from '@/levels.js';
import QueryBuilder from '@/query-builder.js';
import Meet from '@/Models/Meet.js';

levels.shift();
export default {
    name: 'MeetStatisticWindow',

    props: {
        meet: {
            type: Meet,
            required: true,
        },
    },

    data: () => ({
        title: 'Statistic',
        loading: false,
        statistics: null,
        aggregators: [],
        calculators: [],
        aggregatorFields: [
            { text: 'Execution', value: 'execution' },
            { text: 'HD', value: 'hd' },
            { text: 'Time of Flight', value: 'tof' },
            { text: 'Difficulty', value: 'dd' },
            { text: 'Qualification Score', value: 'prelims_score' },
            { text: 'Q2 Score', value: 'semi_final_score' },
            { text: 'Finals Score', value: 'finals_score' },
            { text: 'Final One Score', value: 'final_one_score' },
            { text: 'Final Two Score', value: 'final_two_score' },
            { text: 'Total Score', value: 'total_score' },
        ],
        calculatorFields: [
            { text: 'Count', value: 'count' },
            { text: 'Sum', value: 'sum' },
            { text: 'Average', value: 'average' },
            { text: 'Median', value: 'median' },
            { text: 'Mode', value: 'mode' },
            { text: 'Highest', value: 'ceil' },
            { text: 'Lowest', value: 'floor' },
        ],

        events: [
            { text: 'Trampoline', value: 'TI' },
            { text: 'Double Mini', value: 'DM' },
            { text: 'Tumbling', value: 'TU' },
            { text: 'Synchro', value: 'TS' },
        ],
        levels: levels.map(level => ({ text: level.label, value: level.short })),

        form: {
            events: ['TI', 'DM', 'TU'],
            levels: levels.map(level => level.short),
            genders: ['F', 'M'],
        },
    }),

    methods: {
        async retrieve() {
            try {
                this.loading = true;

                const queryBuilder = new QueryBuilder(`meets/${this.meet.id}/statistics`);

                queryBuilder.array('events', this.form.events);
                queryBuilder.array('levels', this.form.levels);
                queryBuilder.array('genders', this.form.genders);
                queryBuilder.array(
                    'aggregatorFields',
                    this.aggregators.map(aggregator => aggregator.field),
                );
                queryBuilder.array(
                    'aggregators',
                    this.aggregators.map(aggregator => aggregator.aggregator),
                );

                const { data } = await axios.get(queryBuilder.toUrl());

                this.statistics = data.data;
            } catch (error) {
                // eslint-disable-next-line no-console
                console.error(error);
            } finally {
                this.loading = false;
            }
        },

        addAggregator() {
            this.aggregators.push({ field: 'dd', aggregator: 'average' });
        },
    },
};
</script>
